import React, { Component } from "react";
import eventService from "../../services/eventService";
import slideShowService from "../../services/slideshowService";
import storageService from "../../services/storageService";
import AddToPdfButtonComponent from "../addToPdfButtonComponent/addToPdfButton.component";
import { CartState, ECartSSAWorkflow, EDirection, EcartType } from "../enums";
import TrayComponent from "../trayComponent/tray.component";
import { IChallengePDFConfig, IIndexedPDFConfig, IPDFConfig, IPDFIndexedConfig } from "../types/pdfConfig";
import { IPDFCartApplicationState, UserInfo } from "../types/states";
import YourPdfButtonComponent from "../yourPdfButtonComponent/yourPdfButton.component";
import { ECART_DEFAULT_USER_INFO } from "../config";
class PdfCartApplication extends Component<any, IPDFCartApplicationState> {
  constructor(props: null) {
    super(props);
    this.state = {
      challengePDFConfigs: storageService.challengePDFConfigs,
      indexedPDFConfigs: storageService.indexedPDFConfigs,
      indexedPDFConfigsCategories: [],
      indexedPDFOverrideCategoryOrder: false,
      trayOpen: false,
      cartState: CartState.EMPTY,
      enabled: false,
      cartType: EcartType.challenge,
      cartWorkflow: ECartSSAWorkflow.none,
      pdfLink: storageService.pdfLink,
      skipAccountSelection: false,
      investmentAmount: storageService.investmentAmount,
      surrenderChargeSchedule: storageService.surrenderChargeSchedule,
      userInfo: storageService.userInfo,
      selectionMode: storageService.selectionMode,
      selectAllRates : storageService.selectAllRates,
    };
  }

  componentDidMount() {
    eventService.on("pdf-app:disable", this.disable);
    eventService.on("pdf-app:enable", this.enable);
    eventService.on("pdf-app:type-indexed", this.setTypeIndexed);
    eventService.on("pdf-app:type-challenge", this.setTypeChallenge);
    eventService.on("pdf-app:set-ssa-workflow-rates", this.setSSAWorkflowRates);
    eventService.on("pdf-app:set-ssa-workflow-historical", this.setSSAWorkflowHistorical);
    eventService.on("pdf-app:clear", this.clearCart);
    eventService.on("pdf-app:set-investment-amount", this.setInvestmentAmount);
    eventService.on("pdf-app:set-skip-account-selection", this.setSkipAccountSelection);
    eventService.on("pdf-app:set-surrender-charge", this.setSurrenderChargeSchedule);
    eventService.on("pdf-app:set-rates-indexes", this.setRatesIndexes);
    eventService.on("pdf-app:set-rates-arranged-by", this.setRatesArrangedBy);
    eventService.on("pdf-app:set-selection-mode", this.setSelectionMode);
    eventService.on("pdf-app:add-indexed-accounts", this.addIndexed);
    if (this.state.challengePDFConfigs.length > 0) {
      this.setState({
        cartState: CartState.LISTING,
      });
    }

    if (this.state.indexedPDFConfigs.length > 0) {
      // Find all categories of the indexedPDFConfigs and then list them alphabetically to start.
      let categories = this.state.indexedPDFConfigs.map((config) => config.meta.category);
      if (typeof slideShowService.currentChapterController === 'undefined') {
        setTimeout(() => {
          if (typeof slideShowService.currentChapterController !== 'undefined'
            && slideShowService.currentChapterController.name === 'structured_solutions_annuity') {
            // SSA Rates/Performance controllers have to be cart aware.
            slideShowService.currentChapterController.setCartEmpty(false);
            slideShowService.currentChapterController.setInvestmentAmount(this.state.investmentAmount);
          }
        }, 1000);
      }
      this.setState({
        cartState: CartState.LISTING,
        indexedPDFConfigsCategories: [...new Set(categories)].sort(),
      });
    }
  }

  componentWillUnmount() {
    eventService.off("pdf-app:disable", this.disable);
    eventService.off("pdf-app:enable", this.enable);
    eventService.off("pdf-app:type-indexed", this.setTypeIndexed);
    eventService.off("pdf-app:type-challenge", this.setTypeChallenge);
    eventService.off("pdf-app:set-ssa-workflow-rates", this.setSSAWorkflowRates);
    eventService.off("pdf-app:set-ssa-workflow-historical", this.setSSAWorkflowHistorical);
    eventService.off("pdf-app:clear", this.clearCart);
    eventService.off("pdf-app:set-investment-amount", this.setInvestmentAmount);
    eventService.off("pdf-app:set-skip-account-selection", this.setSkipAccountSelection);
    eventService.off("pdf-app:set-surrender-charge", this.setSurrenderChargeSchedule);
    eventService.off("pdf-app:set-rates-indexes", this.setRatesIndexes);
    eventService.off("pdf-app:set-rates-arranged-by", this.setRatesArrangedBy);
    eventService.off("pdf-app:add-indexed-accounts", this.addIndexed);
    eventService.off("pdf-app:set-selection-mode", this.setSelectionMode);
  }

  render() {
    if (!this.state.enabled) return null;
    if (this.state.cartType === EcartType.challenge) return (
      <div className="pdf-app">
        <YourPdfButtonComponent
          count={this.state.challengePDFConfigs.length}
          openTray={this.openTray}
          trayOpen={this.state.trayOpen}
          pdfLink={this.state.pdfLink}
          cartType={this.state.cartType}
        />
        <TrayComponent
          sections={this.state.challengePDFConfigs}
          indexedCategories={this.state.indexedPDFConfigsCategories}
          indexedCategoriesDefaultSort={true}
          selectionMode={this.state.selectionMode}
          closeTray={this.closeTray}
          cartState={this.state.cartState}
          open={this.state.trayOpen}
          moveSlide={this.moveChallenge}
          removeSlide={this.removeChallenge}
          gatherUserInfo={this.gatherUserInfo}
          createPdf={this.generatePdf}
          pdfLink={this.state.pdfLink}
          pdfAccessed={this.pdfAccessed}
          userInfo={this.state.userInfo}
          updateUserInfo={this.updateUserInfo}
          cartType={this.state.cartType}
          cartSSAWorkflow={ECartSSAWorkflow.none}
          surrenderChargeSchedule={this.state.surrenderChargeSchedule}
        />
        <AddToPdfButtonComponent
          onClick={this.addChallenge}
          requireDownload={this.state.pdfLink !== undefined}
          openTray={this.openTray}
          cartType={this.state.cartType}
        />
      </div>
    );
    if (this.state.cartType == EcartType.indexed) return (
      <div className="pdf-app">
        <YourPdfButtonComponent
          count={this.state.indexedPDFConfigs.length}
          openTray={this.openTray}
          trayOpen={this.state.trayOpen}
          pdfLink={this.state.pdfLink}
          cartType={this.state.cartType}
        />
        <TrayComponent
          sections={this.state.indexedPDFConfigs}
          indexedCategories={this.state.indexedPDFConfigsCategories}
          indexedCategoriesDefaultSort={!this.state.indexedPDFOverrideCategoryOrder}
          selectionMode={this.state.selectionMode}
          closeTray={this.closeTray}
          cartState={this.state.cartState}
          open={this.state.trayOpen}
          moveSlide={this.moveIndexed}
          removeSlide={this.removeIndexed}
          gatherUserInfo={this.gatherUserInfo}
          createPdf={this.generatePdf}
          pdfLink={this.state.pdfLink}
          pdfAccessed={this.pdfAccessed}
          userInfo={this.state.userInfo}
          investmentAmount={this.state.investmentAmount}
          skipAccountSelection={this.state.skipAccountSelection}
          updateUserInfo={this.updateUserInfo}
          cartType={this.state.cartType}
          cartSSAWorkflow={this.state.cartWorkflow}
          surrenderChargeSchedule={this.state.surrenderChargeSchedule}
        />
        <AddToPdfButtonComponent
          onClick={this.addIndexed}
          requireDownload={this.state.pdfLink !== undefined}
          openTray={this.openTray}
          cartType={this.state.cartType}
        />
      </div>
    );
  }

  updateUserInfo = (userInfo: UserInfo): void => {
    this.setState({
      userInfo,
    });
    storageService.userInfo = userInfo;
  };

  // Calls out to the HomeController to generate an image of the current Slide. On success
  // add the image to local storage and update the state.
  addChallenge = () => {
    if (slideShowService.currentChapterController.getPDFConfig) {
      this.setCartState(CartState.LOADING);
      this.openTray();
      slideShowService.currentChapterController
        .getPDFConfig()
        .then((pdfConfig: IChallengePDFConfig) => {
          this.storeChallenge(pdfConfig);
          this.setCartState(CartState.LISTING);
        });
    }
  };

  addIndexed = () => {
    if (slideShowService.currentChapterController.getPDFConfig) {
      this.setCartState(CartState.LOADING);
      this.openTray();
      slideShowService.currentChapterController
        .getPDFConfig()
        .then((pdfConfig: IChallengePDFConfig[]) => {
          this.storeIndexed(pdfConfig);
          this.setCartState(CartState.LISTING);
          slideShowService.currentChapterController.clear();
        });
    }
  };

  setInvestmentAmount = (e: Event, investmentAmount: number) => {
    this.setState({
      investmentAmount,
    });
    storageService.investmentAmount = investmentAmount;
  };

  setSkipAccountSelection = (e: Event, skipAccountSelection: boolean) => {
    this.setState({
      skipAccountSelection,
    });
  };

  setSurrenderChargeSchedule = (e: Event, surrenderChargeSchedule: number) => {
    this.setState({
      surrenderChargeSchedule,
    });
    storageService.surrenderChargeSchedule = surrenderChargeSchedule;
  };

  setSelectionMode = (e: Event, selectionMode: string) => {
    this.setState({
      selectionMode,
    });
    storageService.selectionMode = selectionMode;
  };

  setRatesIndexes = (e: Event, ratesIndexes: string) => {
    const updated = {
      ...this.state.userInfo,
      ratesIndexes,
    }
    this.setState({
      userInfo: updated,
    });
    storageService.userInfo = updated;
  }

  setRatesArrangedBy = (e: Event, ratesArrangedBy: string) => {
    const updated = {
      ...this.state.userInfo,
      ratesArrangedBy,
    }
    this.setState({
      userInfo: updated,
    });
    storageService.userInfo = updated;
  }

  gatherUserInfo = () => {
    this.setCartState(CartState.GATHERING_USER_INFO);
  };

  generatePdf = () => {
    this.setCartState(CartState.CREATING);
    // Check cart type to determine which config to use.
    if (this.state.cartType === EcartType.challenge) {
      this.generateChallengePdf();
    } else {
      this.generateIndexedPdf();
    }
  };

  generateIndexedPdf = () => {
    const cleanedConfig: IIndexedPDFConfig[] = this.state.indexedPDFConfigs.map((config) => {
      const { meta, name, image } = config;
      return {
        meta,
        name,
        image,
      };
    });
    const PDF_CONFIG: IPDFIndexedConfig = {
      accounts: cleanedConfig,
      userInfo: this.state.userInfo,
      workflow: this.state.cartWorkflow,
      investmentAmount: this.state.investmentAmount,
      surrenderChargeSchedule: Number(this.state.surrenderChargeSchedule),
    };
    slideShowService
      .viewIndexedPDF(PDF_CONFIG)
      .then((pdfLink: string) => {
        // We still need to know the IDs of the accounts we selected in case we want to
        // apply them to the Custom Brochure flow so we don't clear them out until PDF
        // accessed is called.
        this.setState({
          pdfLink,
        });
        storageService.pdfLink = pdfLink;
        this.setCartState(CartState.DISPLAYING_LINKS);
      })
      .catch((error) => {
        this.setCartState(CartState.ERROR);
        console.log("An error occured while generating the PDF", error);
      });
  };

  generateChallengePdf = () => {
    const cleanedConfig = this.state.challengePDFConfigs.map((config) => {
      const { meta, name, image } = config;
      return {
        meta,
        name,
        image,
      };
    });
    const PDF_CONFIG: IPDFConfig = {
      challenges: cleanedConfig,
      userInfo: this.state.userInfo,
    };
    slideShowService
      .viewPDF(PDF_CONFIG)
      .then((pdfLink: string) => {
        const challengePDFConfigs = [];
        this.setState({
          challengePDFConfigs,
          pdfLink,
        });
        storageService.challengePDFConfigs = challengePDFConfigs;
        storageService.pdfLink = pdfLink;
        this.setCartState(CartState.DISPLAYING_LINKS);
      })
      .catch((error) => {
        this.setCartState(CartState.ERROR);
        console.log("An error occured while generating the PDF", error);
      });
  };
  pdfAccessed = () => {
    this.setState({
      cartState: CartState.EMPTY,
      indexedPDFConfigs: [],
      indexedPDFConfigsCategories: [],
      surrenderChargeSchedule: Number(this.state.surrenderChargeSchedule),
      pdfLink: undefined,
      userInfo: ECART_DEFAULT_USER_INFO,
    });
    storageService.indexedPDFConfigs = [];
    storageService.indexedPDFConfigsCategories = [];
    storageService.surrenderChargeSchedule = Number(this.state.surrenderChargeSchedule);
    storageService.userInfo = ECART_DEFAULT_USER_INFO;
    storageService.clearPdfLink();
  };

  openTray = () => {
    this.setState({
      trayOpen: true,
    });
  };

  closeTray = () => {
    this.setState({
      trayOpen: false,
    });
  };

  setCartState = (cartState: CartState) => {
    this.setState({
      cartState,
    });
  };

  storeIndexed(config: IChallengePDFConfig[]) {
    const indexedPDFConfigs = [...this.state.indexedPDFConfigs, ...config];
    // Derive the categories from the new items and add new categories to the
    // end of the list.
    const indexedPDFConfigsCategories = this.deriveIndexedCategories(config);
    this.setState({
      indexedPDFConfigs,
      indexedPDFConfigsCategories,
    });
    storageService.indexedPDFConfigs = indexedPDFConfigs;
    storageService.indexedPDFConfigsCategories = indexedPDFConfigsCategories;
    slideShowService.currentChapterController.setCartEmpty(indexedPDFConfigs.length === 0);
    console.log(this.state.indexedPDFConfigs);
  }

  // Move a slide around. This being called sets the state that we have customized the order
  // so the Tray won't automatically reorder the categories.
  moveIndexed = (index: number, direction: EDirection) => {
    const indexedPDFConfigsCategories = [...this.state.indexedPDFConfigsCategories];
    if (direction === EDirection.up && index !== 0) {
      [indexedPDFConfigsCategories[index - 1], indexedPDFConfigsCategories[index]] = [
        indexedPDFConfigsCategories[index],
        indexedPDFConfigsCategories[index - 1],
      ];
    } else if (
      direction === EDirection.down &&
      index !== this.state.indexedPDFConfigsCategories.length - 1
    ) {
      [indexedPDFConfigsCategories[index + 1], indexedPDFConfigsCategories[index]] = [
        indexedPDFConfigsCategories[index],
        indexedPDFConfigsCategories[index + 1],
      ];
    }
    this.setState({
      indexedPDFConfigsCategories,
      indexedPDFOverrideCategoryOrder: true,
    });
    storageService.indexedPDFConfigsCategories = indexedPDFConfigsCategories;
  };

  removeIndexed = (config: IChallengePDFConfig) => {
    const indexedPDFConfigs = this.state.indexedPDFConfigs.filter((c) => c !== config);
    const indexedPDFConfigsCategories = this.deriveIndexedCategories(indexedPDFConfigs);
    this.setState({
      indexedPDFConfigs,
      indexedPDFConfigsCategories,
    });
    storageService.indexedPDFConfigs = indexedPDFConfigs;
    storageService.indexedPDFConfigsCategories = indexedPDFConfigsCategories;
  
    // Set if cart is empty on the ChapterController.
    slideShowService.currentChapterController.setCartEmpty(indexedPDFConfigs.length === 0);
  };

  deriveIndexedCategories(config: IChallengePDFConfig[]): string[] {
    // Derive the categories from the list of items and add new categories to the
    // end of the list.
    const categories: string[] = config.map((c) => c.meta.category);
    const indexedPDFConfigsCategories: string[] = [
      ...new Set([...this.state.indexedPDFConfigsCategories, ...categories]),
    ];

    return indexedPDFConfigsCategories;
  };

  storeChallenge(config: IChallengePDFConfig) {
    const challengePDFConfigs = [...this.state.challengePDFConfigs];
    challengePDFConfigs.push(config);
    this.setState({
      challengePDFConfigs,
    });
    storageService.challengePDFConfigs = challengePDFConfigs;
  }

  moveChallenge = (index: number, direction: EDirection) => {
    const challengePDFConfigs = [...this.state.challengePDFConfigs];
    if (direction === EDirection.up && index !== 0) {
      [challengePDFConfigs[index - 1], challengePDFConfigs[index]] = [
        challengePDFConfigs[index],
        challengePDFConfigs[index - 1],
      ];
    } else if (
      direction === EDirection.down &&
      index !== this.state.challengePDFConfigs.length - 1
    ) {
      [challengePDFConfigs[index + 1], challengePDFConfigs[index]] = [
        challengePDFConfigs[index],
        challengePDFConfigs[index + 1],
      ];
    }
    this.setState({
      challengePDFConfigs,
    });
    storageService.challengePDFConfigs = challengePDFConfigs;
  };

  removeChallenge = (index: number) => {
    const challengePDFConfigs = [...this.state.challengePDFConfigs];
    challengePDFConfigs.splice(index, 1);
    this.setState({
      challengePDFConfigs,
    });
    storageService.challengePDFConfigs = challengePDFConfigs;
  };

  get disabled(): boolean {
    return !this.state.enabled;
  }

  disable = () => {
    this.setState({
      enabled: false,
    });
  };
  enable = () => {
    this.setState({
      enabled: true,
    });
  };
  clearCart = () => {
    this.setState({
      challengePDFConfigs: [],
      indexedPDFConfigs: [],
      indexedPDFConfigsCategories: [],
    });
    storageService.challengePDFConfigs = [];
    storageService.indexedPDFConfigs = [];
    storageService.indexedPDFConfigsCategories = [];
  };
  setTypeIndexed = () => {
    this.setState({
      cartType: EcartType.indexed,
    });
  };
  setTypeChallenge = () => {
    this.setState({
      cartType: EcartType.challenge,
    });
  };
  setSSAWorkflowRates = () => {
    this.setState({
      cartWorkflow: ECartSSAWorkflow.rates,
    });
  };
  setSSAWorkflowHistorical = () => {
    this.setState({
      cartWorkflow: ECartSSAWorkflow.historical,
    });
  };
}

export default PdfCartApplication;
